import { useMediaQuery, useTheme } from "@material-ui/core";

export const useThemeBreakpoints = () => {
    const theme = useTheme();

    const isOnlyXs = useMediaQuery(theme.breakpoints.only("xs"));
    const isOnlySm = useMediaQuery(theme.breakpoints.only("sm"));
    const isOnlyMd = useMediaQuery(theme.breakpoints.only("md"));
    const isOnlyLg = useMediaQuery(theme.breakpoints.only("lg"));
    const isOnlyXl = useMediaQuery(theme.breakpoints.only("xl"));

    const isDownXs = useMediaQuery(theme.breakpoints.down("xs"));
    const isDownSm = useMediaQuery(theme.breakpoints.down("sm"));
    const isDownMd = useMediaQuery(theme.breakpoints.down("md"));
    const isDownLg = useMediaQuery(theme.breakpoints.down("lg"));
    const isDownXl = useMediaQuery(theme.breakpoints.down("xl"));

    const isUpXs = useMediaQuery(theme.breakpoints.up("xs"));
    const isUpSm = useMediaQuery(theme.breakpoints.up("sm"));
    const isUpMd = useMediaQuery(theme.breakpoints.up("md"));
    const isUpLg = useMediaQuery(theme.breakpoints.up("lg"));
    const isUpXl = useMediaQuery(theme.breakpoints.up("xl"));

    return {
        isOnlyXs,
        isOnlySm,
        isOnlyMd,
        isOnlyLg,
        isOnlyXl,
        isDownXs,
        isDownSm,
        isDownMd,
        isDownLg,
        isDownXl,
        isUpXs,
        isUpSm,
        isUpMd,
        isUpLg,
        isUpXl,
    };
};
